"use client";

import * as React from "react";
import { Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="call-to-action" className="bg-background py-20 md:py-24 px-6 md:px-24 flex flex-col items-center justify-center text-center overflow-hidden">
      <div ref={ref} className={`max-w-3xl flex flex-col items-center gap-6 md:gap-8 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground tracking-tight">
          Beginne Deine Reise zur Bewegung
        </h2>

        <div className="flex flex-col items-center gap-4 mt-2">
          <Button size="lg" asChild className="rounded-md">
            <a href="mailto:post@claudiachrist.de">
              Schreib mir eine Nachricht
              <Mail className="ml-2 size-4" />
            </a>
          </Button>
        </div>
      </div>
    </section>;
}